import React from "react";
import { BaseEdge, getBezierPath } from "reactflow";

export const LabelEdge = ({ 
    id, 
    sourceX, 
    sourceY, 
    sourcePosition, 
    targetX, 
    targetY, 
    targetPosition, 
    data,
    markerEnd 
}) => {
    // Obtener información sobre edges paralelos
    const edgeIndex = data?.index || 0;
    const totalEdges = data?.total || 1;
    
    // Calcular el offset basado en el índice
    const offset = totalEdges > 1 
        ? ((edgeIndex - (totalEdges - 1) / 2) * 40)
        : 0;
    
    // Calcular el punto medio
    const midX = (sourceX + targetX) / 2;
    const midY = (sourceY + targetY) / 2;
    
    // Aplicar offset perpendicular a la línea
    const dx = targetX - sourceX;
    const dy = targetY - sourceY;
    const length = Math.sqrt(dx * dx + dy * dy);
    
    // Vector perpendicular normalizado
    const perpX = -dy / length;
    const perpY = dx / length;
    
    // Punto de control con offset
    const controlX = midX + perpX * offset;
    const controlY = midY + perpY * offset;
    
    // Crear path cuadrático
    const edgePath = `M ${sourceX},${sourceY} Q ${controlX},${controlY} ${targetX},${targetY}`;
    
    // Calcular posición del label en la curva (t=0.5)
    const t = 0.5;
    const curveX = (1 - t) * (1 - t) * sourceX + 2 * (1 - t) * t * controlX + t * t * targetX;
    const curveY = (1 - t) * (1 - t) * sourceY + 2 * (1 - t) * t * controlY + t * t * targetY;
    
    // Calcular la tangente en el punto medio
    const tangentX = 2 * (1 - t) * (controlX - sourceX) + 2 * t * (targetX - controlX);
    const tangentY = 2 * (1 - t) * (controlY - sourceY) + 2 * t * (targetY - controlY);
    const tangentLength = Math.sqrt(tangentX * tangentX + tangentY * tangentY);
    
    // Vector perpendicular a la tangente
    const normalX = -tangentY / tangentLength;
    const normalY = tangentX / tangentLength;
    
    // Distancia del texto a la curva (NEGATIVO para que esté arriba)
    const textDistance = 0;
    
    // Posición final del texto
    const labelX = curveX + normalX * textDistance;
    const labelY = curveY + normalY * textDistance;

    return (
        <>
            <BaseEdge 
                path={edgePath} 
                markerEnd={markerEnd}
            />
            <text
                x={labelX}
                y={labelY}
                textAnchor="middle"
                dominantBaseline="middle"
                style={{ 
                    fontSize: "12px", 
                    fill: "#555",
                    fontWeight: "500",
                    pointerEvents: "none",
                    background: "#FFFFFF"
                }}
            >
                {data.label}
            </text>
        </>
    );
};

export const edgeTypes = {
    labeled: LabelEdge,
};